import { render, staticRenderFns } from "./term.vue?vue&type=template&id=61cc041e&scoped=true&"
import script from "./term.vue?vue&type=script&lang=ts&"
export * from "./term.vue?vue&type=script&lang=ts&"
import style0 from "./term.vue?vue&type=style&index=0&id=61cc041e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cc041e",
  null
  
)

export default component.exports